import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import DeviceCascader from '@blade-sxp/task-management/components/device-cascader.vue';
let AttrRecognition = class AttrRecognition extends Vue {
    config;
    disabled;
    // recognizationData: IVisitorsPortraitConfigItem = {};
    deviceIdList = [];
    multiple = true;
    searchCondition = {
        excludeUngroupDevice: true,
        filterVpsSupport: true,
    };
    onChangeDevice(val) {
        this.$emit('onChangeDevice', val);
        this.$emit('update:config', this.config);
    }
    onChecked(val) {
        const props = this.config.props;
        const checkedArr = [];
        props &&
            Object.keys(props).forEach((k) => {
                const itemVal = props[k];
                itemVal.isChecked && checkedArr.push(k);
            });
        this.$emit('changeChecked', checkedArr);
        this.$emit('update:config', this.config);
    }
};
__decorate([
    Prop()
], AttrRecognition.prototype, "config", void 0);
__decorate([
    Prop()
], AttrRecognition.prototype, "disabled", void 0);
AttrRecognition = __decorate([
    Component({
        name: 'AttrRecognition',
        components: { DeviceCascader },
        i18n: {
            messages: {
                zh: {
                    device: '设备',
                },
                en: {
                    device: 'Device',
                },
            },
        },
    })
], AttrRecognition);
export default AttrRecognition;
